import { useState, useEffect } from 'react'
import { Link, useNavigate, useParams } from 'react-router-dom'
// import { Helmet } from 'react-helmet'
import { MapContainer, Marker, Popup, TileLayer } from 'react-leaflet'
import { Navigation, Pagination, Scrollbar, A11y, Mousewheel } from "swiper";
import { Swiper, SwiperSlide } from 'swiper/react'
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination'
import { getDoc, doc } from 'firebase/firestore'
import { getAuth } from 'firebase/auth'
import { db } from '../firebase.config'
import Spinner from '../components/Spinner'
import shareIcon from '../assets/svg/shareIcon.svg'
import parkingIcon from "../assets/svg/parkingIcon.svg";
import bedIcon from "../assets/svg/bedIcon.svg";
import bathtubIcon from "../assets/svg/bathtubIcon.svg";
import emailIcon from "../assets/svg/emailIcon.svg";
import furnitureIcon from "../assets/svg/furnitureIcon.svg";
import arrowRight from "../assets/svg/keyboardArrowRightIcon.svg"

function Listing() {
  const [listing, setListing] = useState(null)
  const [loading, setLoading] = useState(true)
  const [shareLinkCopied, setShareLinkCopied] = useState(false)

  const navigate = useNavigate()
  const params = useParams()
  const auth = getAuth()

  useEffect(() => {
    const fetchListing = async () => {
      const docRef = doc(db, 'listings', params.listingId)
      const docSnap = await getDoc(docRef)

      if (docSnap.exists()) {
        setListing(docSnap.data())
        setLoading(false)
      }
    }

    fetchListing()
  }, [ navigate, params.listingId ])

  function formatNumberWithCommas(number) {
    return number.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
  }

  if (loading) {
    return <Spinner />
  }

  return (
    <main>
      {/* <Helmet>
        <title>{listing.name}</title>
      </Helmet> */}
      <Swiper
        modules={[Navigation, Pagination, Scrollbar, A11y, Mousewheel]}
        slidesPerView={1}
        pagination={{ clickable: true }}
        navigation
        style={{ height: '300px' }}
>
        {listing.imgUrls.map((url, index) => {
            return (
              <SwiperSlide key={index}>
                  <div
                      className='swiperSlideDiv'
                      style={{
                        background: `url(${listing.imgUrls[index]}) center no-repeat`,
                        backgroundSize: 'cover',
                      }}
                  ></div>
              </SwiperSlide>
            );
          })}
      </Swiper>

      <div
        className='shareIconDiv'
        onClick={() => {
          navigator.clipboard.writeText(window.location.href)
          setShareLinkCopied(true)
          setTimeout(() => {
            setShareLinkCopied(false)
          }, 2000)
        }}
      >
        <img src={shareIcon} alt='' />
      </div>

      {shareLinkCopied && <p className='linkCopied'>Link Copied!</p>}

      <div className='listingDetails'>
      <p className='listingName'>
        {listing.name} - $
        {listing.offer
          ? formatNumberWithCommas(listing.discountedPrice)
          : formatNumberWithCommas(listing.regularPrice)}
      </p>
        <p className='listingLocation'>{listing.location}</p>
        <p className='listingType'>
          For {listing.type === 'rent' ? 'Rent' : 'Sale'}
        </p>
        {listing.offer && (
          <p className='discountPrice'>
            ${formatNumberWithCommas(
              listing.regularPrice - listing.discountedPrice
            )} discount
          </p>
        )}

        <ul className='listingDetailsList'>
          <li>
            <img
              className="align-bottom"
              src={bedIcon}
              alt="bedrooms"
              height="19px"
              width="19px"
            /> {listing.bedrooms > 1
              ? `${listing.bedrooms} Bedrooms`
              : '1 Bedroom'}
          </li>
          <li>
          <img
              className="align-bottom"
              src={bathtubIcon}
              alt="bedrooms"
              height="19px"
              width="19px"
          /> {listing.bathrooms > 1
              ? `${listing.bathrooms} Bathrooms`
              : '1 Bathroom'}
          </li>

          {listing.parking ? (
            <li>
              <img
                className="align-bottom"
                src={parkingIcon}
                alt="parking"
                height="23px"
                width="22px"
              /> Parking
            </li>
          ) : null
          }

          {listing.furnished ? (
            <li>
              <img
                className="align-bottom"
                src={furnitureIcon}
                alt="parking"
                height="23px"
                width="22px"
              /> Furnished
            </li>
          ) : null
          }
        </ul>

        <p className='listingLocationTitle'>Location</p>

        <div className='leafletContainer'>
          <MapContainer
            style={{ height: '100%', width: '100%' }}
            center={[listing.geolocation.lat, listing.geolocation.lng]}
            zoom={13}
            scrollWheelZoom={false}
          >
            <TileLayer
              attribution='&copy; <a href="http://osm.org/copyright">OpenStreetMap</a> contributors'
              url='https://{s}.tile.openstreetmap.de/tiles/osmde/{z}/{x}/{y}.png'
            />

            <Marker
              position={[listing.geolocation.lat, listing.geolocation.lng]}
            >
              <Popup>{listing.location}</Popup>
            </Marker>
          </MapContainer>
        </div>

        {auth.currentUser?.uid !== listing.userRef && (
          <Link
            to={`/contact/${listing.userRef}?listingName=${listing.name}`}
            className='createListing'
          >
            <img
              className="align-bottom"
              src={emailIcon}
              alt="email"
              height="26px"
              width="26px"
            /> <p> Contact Owner</p>
            <img src={arrowRight} alt="arrow right" />
          </Link>
        )}
      </div>
    </main>
  )
}

export default Listing